<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left></vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items [locationId]="'qa-page'"></vdr-action-bar-items>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  class="mt-2"
  id="QA-table"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="qa-table"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  ></vdr-bulk-action-menu>
  <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    [searchTermPlaceholder]="'Search By question content'"
  />
  <vdr-dt2-column
    [heading]="'common.id' | translate"
    id="id"
    [hiddenByDefault]="true"
    [sort]="sorts.get('id')"
  >
    <ng-template let-qa="item">
      {{ qa.id }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'catalog.product' | translate"
    id="product"
    [hiddenByDefault]="false"
  >
    <ng-template let-qa="item">
      <a
        class="button-ghost"
        [routerLink]="['/catalog/products', qa.product.id]"
        >{{ qa.product.name }}
        <clr-icon shape="arrow right" />
      </a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'customer.customer' | translate"
    id="customer"
    [hiddenByDefault]="false"
  >
    <ng-template let-qa="item">
      <a
        class="button-ghost"
        [routerLink]="['/extensions/ui-customer', qa.customer.id]"
        >{{ qa.customer.firstName }} {{ qa.customer.lastName }}
        <clr-icon shape="arrow right" />
      </a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'qa.question' | translate"
    id="question"
    [hiddenByDefault]="true"
  >
    <ng-template let-qa="item">
      <div
        style="
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        "
      >
        {{ qa.title }}
      </div>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'qa.secret' | translate"
    id="secret"
    [hiddenByDefault]="false"
  >
    <ng-template let-qa="item">
      <vdr-chip [colorType]="!qa.secret ? 'success' : 'warning'">
        {{ qa.secret ? "Private" : "Show" }}
      </vdr-chip>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.status' | translate"
    id="status"
    [hiddenByDefault]="false"
  >
    <ng-template let-qa="item">
      <!-- <vdr-chip
        [colorType]="qa.status === 'WaitResponse' ? 'warning' : 'success'"
      >
        {{ qa.status | formatStatus }}
      </vdr-chip> -->

      <custom-chip
      [backgroundColor]="getChipBg(qa.status)" 
      [color]="getChipColor(qa.status)" 
      >
        {{ qa.human ? "[Human]" : "[AI]" }}{{ qa.status | formatStatus }}
      </custom-chip>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.delete' | translate"
    id="delete"
    [hiddenByDefault]="true"
  >
    <ng-template let-qa="item">
      <vdr-chip [colorType]="qa.isDeleted ? 'warning' : 'success'">
        {{ qa.isDeleted ? "Deleted" : "Active" }}
      </vdr-chip>
    </ng-template>
  </vdr-dt2-column>
  <!-- <vdr-dt2-column
    [heading]="'common.operator' | translate"
    id="operator"
    [hiddenByDefault]="false"
  >
    <ng-template let-qa="item">
      <div style="white-space: nowrap">
        {{ qa.comments | getOperator }}
      </div>
    </ng-template>
  </vdr-dt2-column> -->
  <vdr-dt2-column
    [heading]="'common.created-at' | translate"
    id="createdAt"
    [hiddenByDefault]="true"
  >
    <ng-template let-qa="item">
      {{ qa.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.action' | translate"
    id="action"
    [hiddenByDefault]="false"
  >
    <ng-template let-qa="item">
      <button (click)="onReplyClick(qa)" class="button-ghost">View</button>
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
